<template>
	<div class="ReLeadServices">
		<template v-if="value.length>0">
			<!-- <pre v-for="obj in value">{{obj.id}} - {{ obj.BP_NAME }} - {{ obj.agent_name }} - {{ obj.STAGE_NAME }} - {{ obj.STATUS }} [{{ client_phone }}]</pre> -->
			<el-table 
				:data="value" 
				style="width: 100%"  
				ref="tableData"
			>			
				<el-table-column
					label="ID услуги"
					width="100"
					prop="id"
				></el-table-column>	
				<el-table-column
					label="наименование услуги"
					prop="BP_NAME"
				></el-table-column>	
				<el-table-column
					label="Этап"
					prop="STAGE_NAME"
				></el-table-column>	
				<el-table-column
					label="Ответственный"
					prop="agent_name"
				></el-table-column>	
				<el-table-column
					label="Статус услуги"
					prop="STATUS"
				></el-table-column>	
				<el-table-column
					label="Позвонить"
					width="180"
				>
					<template v-slot="scope">
						<RePhoneCallButton
							:phone="client_phone"
							:lead_id="$route.params.lead_id"
						/>
					</template>
				</el-table-column>	
			</el-table>
		</template>
		<template v-else><span>Услуг не найдено</span></template>
	</div>
</template>

<script>
/*
я тут до конца осознал про v-model и props value внутри компонента:
радовался тому что в value можно писать и всё работает - нихрена. 
1) Если value сложный тип (например массив или объект) - тогда можно элементы массива/объекта и ничего за это не будет, т.к. ЖС говно
2) Если тип простой string или number - то хер чё поменяешь в value, только this.$emit('input', 'ЗНАЧЕНИЕ');
3) Если напрямую переписывать сложные тип, например value = {key:'value'} - то хер, будет ошибка
а ещё во всех слуаях он выдаст ошибку, но значение в value запишет
*/
/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/
	import { Table, TableColumn } from 'element-ui';
	import RePhoneCallButton from "src/our_components/RePhoneCallButton.vue";
	export default {
		name: 'ReLeadServices',
		components: {
			[Table.name]: Table,
    		[TableColumn.name]: TableColumn,
			RePhoneCallButton,
		},
		props: {
			client_phone: [String,Number],
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: {
				type: Array,
				default: function (){return [];},
			}
		},
		data () {
			return {
				ver: 1,
				bufferValue: '',
			}
		},
		watch:{
			/*
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
			},
			*/
		},
		computed: {

		},
		methods: {
			
		},
		mounted(){

		}
	}
</script>
<style scoped>

</style>
